import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { formatDistance, parse } from "date-fns";
import { ReplaySubject, firstValueFrom, map, tap } from 'rxjs';
import { Bounce, TeamMemberForBackoffice, TransformedBounce } from './bounce.type';

@Injectable({
    providedIn: 'root'
})
export class BouncesService{

    bounces$ = new ReplaySubject<Bounce[]>(1);
    bouncesNumber$ = new ReplaySubject<number>(1);

    constructor(private http: HttpClient){}

    async query() {
        return await firstValueFrom(this.http.get(`/admin/bounces/`).pipe(
            map((bounces: Bounce[]) => this.formatBounces(bounces)),
            tap((bounces: TransformedBounce[]) => {
                this.bouncesNumber$.next(bounces.length);
                this.bounces$.next(bounces);
            })
        ));
    }

    async removeBounce(teamMemberId: string){
        return await firstValueFrom(this.http.delete('/admin/bounces/' + teamMemberId));
    }

    private formatBounces(bounces: Bounce[]): TransformedBounce[] {
        const formatedBounces = bounces.map((bounce) => {
            
            const lastMoodDate = bounce.teamMember.lastMoodDate !== 'Never' ? fromNow(bounce.teamMember.lastMoodDate) : 'Never';
            const createdAgo = fromNow(bounce.teamMember.created);
            
            const formatedBounce = {
                ...bounce,
                teamMember: {
                    ...bounce.teamMember,
                    createdAgo: createdAgo,
                    lastMoodDateAgo: lastMoodDate
                }
            }    

            return formatedBounce;
        })
        return formatedBounces;
    }

}

const fromNow = function (date: string) {
    return formatDistance(parse(date, 'dd/MM/yyyy', new Date()), new Date(), {
        addSuffix: true
      });
}

export const generateMailTo = (teamMember: TeamMemberForBackoffice) => {

    const recipient = '';
    let subject = '';
    let body = '';

    if(teamMember.language === 'fr'){
        subject = 'Problème d\'adresse email';
        body = 'Bonjour, \n' +
            'Nous avons rencontré un problème pour envoyer un email à l\'adresse suivante : '+ teamMember.email +' \n' +
            'Pouvez-vous, s\'il vous plaît, vérifier si cette adresse est la bonne ou s\'il y a une faute de frappe? \n' +
            'Nous avons désactivé ce compte en attendant.\n' +
            'Merci, \n' +
            '\n' +
            'Nicolas\n';
    }else{
        subject = 'Issue with email address';
        body = 'Hello, \n' +
            'We had an issue delivering an email to the following address: '+ teamMember.email +' \n' +
            'Could you please check if it is the right address or if there is a typo?\n' +
            'Meanwhile, we disabled this account.\n' +
            'Thank you,\n' +
            '\n' +
            'Nicolas\n';
    }

    const mailto = 'mailto:'+recipient+'?Subject='+subject+'&Body='+body;

    return encodeURI(mailto).replace(' ', '%20');
}